import type { JSXElement } from "solid-js"

export default function TR (header: JSXElement, data: JSXElement) {
  return <tr><th>{header}</th><td>{data}</td></tr>
}